export default {"src":"https://webcdn.trailways.ca/_next/static/media/hamburger.969d7b9c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};